export interface CitizensServicesCategory {
  id?: string;
  categoryUniqueId?: string;
  categoryName?: string;
  categoryDescription?: string;
}


export enum SocialGroups {
  Children = "Children",
  Special_Needs = "Special_Needs",
  Elderly = "Elderly",
  Women = "Women",
  Youth = "Youth",
}
